import { createReducer, on } from '@ngrx/store';
import { CreateMarketCategoryDto, MarketCategoryDto } from '@careapp-group/ng-sdk';

import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { OrganisationContextSwitch } from '../actions/meta.actions';
import { mergeReducers } from '../entity-state/merge-reducers';
import { MarketManagementCategories } from './market-management-category.actions';

export class MarketManagementCategoryReducer extends CaEntityReducer<
  MarketCategoryDto,
  BaseFilterType
> {
  marketManagementCategoryReducer = createReducer(
    this.initialState,
    on(OrganisationContextSwitch, () => this.initialState)
  );

  public reducer(state, action) {
    return this.combinedReducer(state, action);
  }

  public combinedReducer = mergeReducers(this.marketManagementCategoryReducer, this.entityReducer);
}

export const state = new MarketManagementCategoryReducer(MarketManagementCategories);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
